import { makeStyles } from '@material-ui/core/styles';

import { parseRgbaColor } from '@pro/web-common/utils/style';


export const styles = makeStyles((theme) => ({
  expansionPanelExpanded: {
    margin: '0!important',
  },
  expansionPanelRoot: {
    boxShadow: 'none',
    marginBottom: theme.spacing(1 / 2),

    '&:before': {
      display: 'none',
    },
  },
  expansionPanelSummaryRoot: ({ isSubsection, sectionHeaderColor, sectionHeaderTextColor, subSectionHeaderColor, subSectionHeaderTextColor }) => ({
    backgroundColor: parseRgbaColor(isSubsection ? subSectionHeaderColor : sectionHeaderColor),
    color: parseRgbaColor(isSubsection ? subSectionHeaderTextColor : sectionHeaderTextColor),
    padding: theme.spacing(0, 1),
    borderRadius: theme.shape.borderRadius,

    '&, &.Mui-expanded': {
      minHeight: theme.spacing(3),
    },
  }),
  expansionPanelSummaryContent: {
    '&, &.Mui-expanded': {
      margin: theme.spacing(1 / 2, 0),
    },
  },
  expansionPanelSummaryExpanded: {},
  expansionPanelSummaryExpandIcon: ({ isSubsection, sectionHeaderTextColor, subSectionHeaderTextColor }) => ({
    color: parseRgbaColor(isSubsection ? subSectionHeaderTextColor : sectionHeaderTextColor),
    padding: theme.spacing(0, 1),
  }),
  expansionPanelDetailsRoot: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
  html: ({ fontColor }) => ({
    margin: theme.spacing(1 / 2, 0),
    color: parseRgbaColor(fontColor),
  }),
  imageContainer: {
    display: 'block',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  image: {
    display: 'block',
    maxWidth: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));
